<button
  pButton
  type="button"
  [label]="'Export' | translate"
  class="p-button-secondary export-btn"
  [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
  [disabled]="disabled || loading"
  (click)="export.emit()">
</button>
